// Metadata centralizada de los posts del blog. La página /blog la usa para
// listar artículos y los componentes individuales para datos canónicos.
// El campo slug es el path después de /blog/.

const posts = [
  {
    slug: 'real-decreto-2026-fichaje-digital',
    title: 'Real Decreto 2026 sobre fichaje digital: lo que cambia para tu empresa',
    description: 'Análisis del nuevo Real Decreto sobre control horario digital obligatorio en España: novedades, plazos, requisitos técnicos y cómo prepararse.',
    excerpt: 'El nuevo Real Decreto endurece el registro de jornada: interoperabilidad con la ITSS, registros electrónicos, geolocalización... Te explicamos qué cambia y qué tienes que hacer ya.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Normativa Laboral',
    readMinutes: 9,
    featured: true,
  },
  {
    slug: 'sanciones-no-fichar-2026',
    title: 'Sanciones por no fichar en 2026: cuantías, casos reales y cómo evitarlas',
    description: 'Multas actualizadas 2026 por incumplir el registro de jornada en España. Tabla completa LISOS, agravantes, casos reales de la ITSS y prevención.',
    excerpt: 'Las multas por no fichar pueden llegar a 187.515 €. Repasamos las cuantías 2026, los agravantes que las disparan y cómo blindar a tu empresa frente a la inspección.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Normativa Laboral',
    readMinutes: 8,
  },
  {
    slug: 'inspeccion-trabajo-control-horario',
    title: 'Inspección de Trabajo y control horario: qué piden y cómo responder',
    description: 'Guía práctica para superar una visita de la Inspección de Trabajo en materia de jornada: documentos, plazos, errores frecuentes y plantilla de respuesta.',
    excerpt: 'Si la ITSS llama a tu puerta, tienes 10 días. Te enseñamos qué documentos preparan los inspectores, cómo entregarlos y cuáles son los errores que más sanciones generan.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Normativa Laboral',
    readMinutes: 10,
  },
  {
    slug: 'como-elegir-sistema-fichaje',
    title: 'Cómo elegir un sistema de fichaje: checklist y comparativa 2026',
    description: 'Guía para escoger software de control horario: criterios técnicos, legales, comparativa entre soluciones y plantilla de evaluación descargable.',
    excerpt: '20 criterios objetivos para escoger un sistema de fichaje en 2026: legales, técnicos, de usabilidad y de coste. Más comparativa rápida con las opciones más extendidas en España.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Guías',
    readMinutes: 9,
  },
  {
    slug: 'geolocalizacion-fichajes-rgpd',
    title: 'Geolocalización en fichajes: ¿es legal? Guía RGPD + AEPD',
    description: 'Análisis legal del uso de geolocalización para fichar: marco RGPD, jurisprudencia AEPD, requisitos de proporcionalidad e información al trabajador.',
    excerpt: 'Sí, puedes geolocalizar fichajes, pero con límites. Te contamos qué dice el RGPD, qué ha resuelto la AEPD y cómo configurarlo sin riesgo de sanción.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Privacidad',
    readMinutes: 8,
  },
  {
    slug: 'plantilla-excel-control-horario',
    title: 'Plantilla Excel de control horario gratis (y por qué no es suficiente)',
    description: 'Plantilla Excel descargable para registro de jornada y análisis de sus limitaciones legales y prácticas frente a un sistema digital.',
    excerpt: 'Descarga gratis nuestra plantilla Excel de registro horario. Pero antes de usarla, lee por qué la AEPD y la ITSS no la aceptan como prueba fiable de cumplimiento.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Recursos',
    readMinutes: 6,
  },
  {
    slug: 'diferencia-control-horario-registro-jornada',
    title: 'Diferencia entre control horario y registro de jornada',
    description: 'Aclaración terminológica con base legal: qué es exactamente el registro de jornada, qué es el control horario y por qué la confusión expone a sanciones.',
    excerpt: 'Aunque se usan como sinónimos, control horario y registro de jornada no son lo mismo. La diferencia importa cuando llega la inspección.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Normativa Laboral',
    readMinutes: 6,
  },
  {
    slug: 'fichaje-teletrabajo-remoto',
    title: 'Fichaje en remoto y teletrabajo: marco legal y soluciones',
    description: 'Cómo registrar la jornada de empleados en teletrabajo cumpliendo Ley 10/2021 y RD-ley 8/2019: derechos, obligaciones y tecnología recomendada.',
    excerpt: 'El teletrabajo no exime del registro de jornada. Repasamos la Ley 10/2021 de trabajo a distancia, sus exigencias y cómo cumplirlas sin invadir la privacidad.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Modalidades',
    readMinutes: 8,
  },
  {
    slug: 'asesorias-control-horario-clientes',
    title: 'Asesorías laborales: cómo gestionar el control horario de varios clientes',
    description: 'Guía para asesorías que gestionan registro de jornada de varias empresas: arquitectura multi-tenant, delegación de acceso, facturación e informes.',
    excerpt: 'Si tu asesoría lleva la nómina y el laboral de varias empresas, gestionar el fichaje desde un único panel deja de ser un lujo. Te contamos cómo se hace.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Asesorías',
    readMinutes: 7,
  },
  {
    slug: 'banca-horas-vs-horas-extras',
    title: 'Banca de horas vs horas extras: cómo computa cada una',
    description: 'Diferencias legales y prácticas entre la bolsa horaria/banca de horas y las horas extraordinarias: cómputo, retribución, límites y casos prácticos.',
    excerpt: 'Bolsa horaria, banca de horas, horas extras... no son sinónimos. Cómo se computan, cómo se retribuyen y qué configurar en tu sistema de fichaje para que cuadre.',
    date: '2026-05-04',
    dateDisplay: '4 de mayo de 2026',
    category: 'Gestión',
    readMinutes: 7,
  },
  {
    slug: 'registro-horario-obligatorio-espana',
    title: 'Registro Horario Obligatorio en España 2026: Guía Completa para Pymes',
    description: 'Guía completa sobre la obligación de registro horario en España (RD-ley 8/2019). Qué empresas deben cumplir, sanciones, cómo implementarlo y soluciones digitales.',
    excerpt: 'La guía de referencia sobre el registro de jornada en España: marco legal, obligaciones, sanciones y opciones de implementación para pymes.',
    date: '2026-04-05',
    dateDisplay: '5 de abril de 2026',
    category: 'Normativa Laboral',
    readMinutes: 10,
  },
]

// Orden por fecha desc — el primero (featured) sale destacado en /blog.
export const blogPosts = posts

export function getPostBySlug(slug) {
  return posts.find((p) => p.slug === slug)
}

export function getRelatedPosts(slug, limit = 3) {
  const current = getPostBySlug(slug)
  if (!current) return posts.slice(0, limit)
  return posts
    .filter((p) => p.slug !== slug)
    .sort((a, b) => {
      const sameCat = (p) => (p.category === current.category ? -1 : 0)
      return sameCat(a) - sameCat(b)
    })
    .slice(0, limit)
}
